import { useEffect, useState } from 'react';

export function subscribeToClock(onTick: () => void, intervalMs: number): () => void {
  const timer = setInterval(onTick, intervalMs);
  document.addEventListener('visibilitychange', onTick);
  return () => {
    clearInterval(timer);
    document.removeEventListener('visibilitychange', onTick);
  };
}

export const useNow = (intervalMs: number) => {
  const [now, setNow] = useState(Date.now);

  useEffect(() => subscribeToClock(() => setNow(Date.now()), intervalMs), [intervalMs]);

  return now;
};
